"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LateralEffluentSpreader = void 0;
const effluentAreaCalculation_1 = require("../../DefinitionAndHelpers/Helpers/Effluent/effluentAreaCalculation");
const index_1 = require("../../DefinitionAndHelpers/index");
const EffluentTracker_1 = require("./EffluentTracker");
const typeName = 'LateralEffluentSpreader';
const dev = process.env.REACT_APP_DEBUG;
const debug = dev && false;
class LateralEffluentSpreader extends EffluentTracker_1.EffluentTracker {
    constructor(ob) {
        var _a;
        super({ ...ob, type: typeName });
        this.singleDeviceControl = ob.singleDeviceControl || false;
        this.span = (_a = ob.span) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Updated relevant runs. Allows runs of type LateralEffluentSpreader
     * @param runList
     * @returns runs of correct run type
     */
    getRelevantRuns(runList) {
        debug && console.log('Using lateral specific - getRelevantRuns');
        let filteredRuns = runList.filter((run) => run.pathType === index_1.EFFLUENT_PATH_TYPE.LateralEffluentSpreader);
        return filteredRuns;
    }
    /**
     * Function to get the spread LatLngs, and area (m^2), of the raw run
     * @returns LatLngs and area (m^2) obj
     */
    getSpreadOfRawRun(relevantRun, rawPath = this.path) {
        debug && console.log('Using lateral specific - getSpreadOfRawRun');
        const parsedPath = rawPath !== null && rawPath !== void 0 ? rawPath : this.path;
        if (parsedPath && parsedPath.length > 1) {
            let mappedPath = parsedPath;
            if (relevantRun) {
                mappedPath = this.getPathOnRun(parsedPath, relevantRun);
            }
            let positions = this.throwDistance && this.span && (0, effluentAreaCalculation_1.covertLateralPathToAreaV2)(mappedPath, this.throwDistance, this.span, relevantRun);
            if (positions) {
                let turfBoundary = index_1.EffluentSpreaderHelper.convertPositionToTurf(positions);
                let turfArea = index_1.EffluentSpreaderHelper.createArea([turfBoundary]);
                let area = index_1.EffluentSpreaderHelper.getAreaMeter(turfArea);
                return { positions, area };
            }
        }
        return undefined;
    }
    // getSpreadOfFilteredRun(relevantRun?: EffluentPath, path: Position[] | undefined = this.mappedPath): AreaData | undefined {
    //   debug && console.log('Should be using default - getSpreadOfMappedRun');
    //   if (path) {
    //     if (path.length > 1) {
    //       // may just call RAW
    //       let positions = covertLateralPathToAreaV2(path, this.throwDistance, this.span, relevantRun);
    //       if (positions) {
    //         let turfBoundary = EffluentSpreaderHelper.convertPositionToTurf(positions);
    //         let turfArea = EffluentSpreaderHelper.createArea([turfBoundary]);
    //         let area = EffluentSpreaderHelper.getAreaMeter(turfArea);
    //         return { positions, area };
    //       }
    //     }
    //   }
    //   return this.getSpreadOfRawRun(relevantRun);
    // }
    getSpreadOfMappedRun(relevantRun, rawPath = this.mappedPath) {
        debug && console.log('Should be using default - getSpreadOfMappedRun');
        const parsedPath = rawPath !== null && rawPath !== void 0 ? rawPath : this.mappedPath;
        if (parsedPath) {
            if (parsedPath.length > 1 && this.throwDistance && this.span) {
                // may just call RAW
                let positions = (0, effluentAreaCalculation_1.covertLateralPathToAreaV2)(parsedPath, this.throwDistance, this.span, relevantRun);
                if (positions) {
                    let turfBoundary = index_1.EffluentSpreaderHelper.convertPositionToTurf(positions);
                    let turfArea = index_1.EffluentSpreaderHelper.createArea([turfBoundary]);
                    let area = index_1.EffluentSpreaderHelper.getAreaMeter(turfArea);
                    return { positions, area };
                }
            }
        }
        return this.getSpreadOfRawRun(relevantRun);
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            singleDeviceControl: {
                type: 'Boolean',
                editable: true,
                default: false,
                label: 'Single Device Control',
                required: true,
            },
            span: {
                type: 'Number',
                editable: true,
                label: 'Lateral Span Length (m)',
                name: 'Lateral Span Length (m)',
                description: 'Pivot Span Length (m)',
                required: true,
            },
            location_lat: {
                type: 'Number',
                precision: 5,
                editable: false,
                label: 'Lateral Lat',
                limits: {
                    min: -90,
                    max: 90,
                },
                required: false,
            },
            location_lng: {
                type: 'Number',
                precision: 5,
                editable: false,
                label: 'Lateral Lng',
                limits: {
                    min: -180,
                    max: 180,
                },
                required: false,
            },
        };
    }
}
exports.LateralEffluentSpreader = LateralEffluentSpreader;
